import type { SVGProps } from 'react';

import type { FiatCurrency } from '#src/__generated__/globalTypes.ts';
import { faFiatCurrencySymbols } from '#src/lib/fiat.ts';
import { unitMapping, type Unit } from '#src/lib/style.ts';
import type { Color } from '#src/style/types.ts';

type Props = { size?: Unit; color?: Color; fiatCurrency: FiatCurrency };

export const Cash = ({
  size = 2,
  color = 'currentColor',
  fiatCurrency,
  ...props
}: Omit<SVGProps<SVGSVGElement>, 'color'> & Props) => {
  const {
    icon: [width, height, , , path],
    fillRule,
    clipRule,
  } = faFiatCurrencySymbols[fiatCurrency];

  return (
    <svg
      style={{ width: unitMapping[size], height: unitMapping[size] }}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule={fillRule}
        clipRule={clipRule}
        d={path as string}
        fill={color}
      />
    </svg>
  );
};
